module.exports = __webpack_public_path__ + "media/images/pic/courses/zestaw-powitalny-gratis-1a4dccfe60e3170ff861ddee97d893d2.png";